import { Locale, type LocalizedString } from "../Locale.js";

export const myAccountPathMap = {
	[Locale.cs]: "muj-ucet" as const,
} satisfies LocalizedString;
